<template>
  <div class="box">
    <el-tabs
      tab-position="left"
      style="height:650px;"
      @tab-click="handleClick"
      v-model="activeName"
    >
      <el-tab-pane label="所有" v-if="viewtab.all">
        <!-- <div > -->
        <el-input
          style="width:200px;margin-bottom:20px"
          size="small"
          placeholder="请输入测量点名称"
          v-model="searchvalue"
          @change="searchinput"
        ></el-input>

        <el-table
          :data="usermeasureTable"
          border
          style="width: 100%"
          @row-click="clicktable"
          height="581"
          :highlight-current-row="true"
        >
          <el-table-column prop="name" label="测量点名称"></el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
          <el-table-column prop="id" label="id" v-if="false"></el-table-column>
        </el-table>
        <!-- </div> -->
      </el-tab-pane>
      <el-tab-pane label="架构" v-if="viewtab.framework">
        <div class="choice-warp">
          <div class="choice-left">
            <el-tree
              :data="frameworkData"
              :props="defaultFrameworkProps"
              @node-click="bindNodeClick"
              style="height:613px"
            ></el-tree>
          </div>
          <div class="choice-right">
            <el-table
              :data="measureTable"
              border
              style="width: 100%"
              @row-click="clicktable"
              height="613"
              :highlight-current-row="true"
            >
              <el-table-column
                prop="name"
                label="测量点名称"
                width="180"
              ></el-table-column>
              <el-table-column
                prop="remark"
                label="备注"
                width="180"
              ></el-table-column>
              <el-table-column
                prop="id"
                label="id"
                width="180"
                v-if="false"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="视图" v-if="viewtab.view">
        <div class="choice-warp">
          <div class="choice-left">
            <el-tree
              :data="viewData"
              :props="defaultFrameworkProps"
              @node-click="bindNodeClick"
              style="height:613px"
            ></el-tree>
          </div>
          <div class="choice-right">
            <el-table
              :data="viewmeasureTable"
              border
              style="width: 100%"
              @row-click="clicktable"
              height="613"
              :highlight-current-row="true"
            >
              <el-table-column
                prop="measureName"
                label="测量点名称"
                width="180"
              ></el-table-column>
              <el-table-column
                prop="measureRemark"
                label="备注"
                width="180"
              ></el-table-column>
              <el-table-column
                prop="measureId"
                label="id"
                width="180"
                v-if="false"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="分类分组" v-if="viewtab.class">
        <div class="choice-warp">
          <div class="choice-left">
            <el-tree
              :data="classData"
              :props="defaultFrameworkClassProps"
              @node-click="bindNodeClick"
              style="height:613px"
            ></el-tree>
          </div>
          <div class="choice-right">
            <el-table
              :data="classmeasureTable"
              border
              style="width: 100%"
              @row-click="clicktable"
              height="613"
              :highlight-current-row="true"
            >
              <el-table-column
                prop="name"
                label="测量点名称"
                width="180"
              ></el-table-column>
              <el-table-column
                prop="remark"
                label="备注"
                width="180"
              ></el-table-column>
              <el-table-column
                prop="id"
                label="id"
                width="180"
                v-if="false"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { creatMenuJson } from "@/utils/index.js";
import * as utils from "@/utils/index.js";
import { isNull } from "util";
import creatTreeJson from "@/utils/tree.js";
export default {
  props: {
    viewtab: {
      type: Object,
      default: () => ({
        all: true,
        framework: true,
        view: true,
        class: true,
      }),
    },
  },
  data() {
    return {
      activeName: "0",
      searchvalue: "",
      frameworkData: [],
      viewData: [],
      userTable: [],
      defaultFrameworkProps: {
        label: "name",
        children: "children",
      },
      defaultFrameworkClassProps: {
        children: "groups",
      },
      classData: [],
      viewmeasureTable: [],
      measureTable: [],
      usermeasureTable: [],
      classmeasureTable: [],
    };
  },
  mounted() {
    if (this.viewtab.all) {
      this.activeName = "0";
    } else if (this.viewtab.framework) {
      this.activeName = "1";
    } else if (this.viewtab.view) {
      this.activeName = "2";
    } else if (this.viewtab.class) {
      this.activeName = "3";
    } else {
      this.activeName = "0";
    }
    this.handleClick();
  },
  watch: {},
  methods: {
    //搜索功能
    searchinput() {
      let vm = this;
      let arr = [];
      for (var i = 0; i < this.userTable.length; i++) {
        if (this.userTable[i].name.toString().indexOf(vm.searchvalue) >= 0) {
          arr.push(this.userTable[i]);
        }
      }
      vm.usermeasureTable = arr;
    },
    //  用户列表计量点
    getUserMeasureId() {
      this.$api.measure
        .getViewableMeasures(this.$store.state.user.currentCompanyId)
        .then((res) => {
          this.userTable = JSON.parse(JSON.stringify(res.data));
          this.usermeasureTable = JSON.parse(JSON.stringify(res.data));
        });
    },
    //获取组织架构节点
    bindShowMeasureChoice() {
      let vm = this;
      vm.$api.orgStructNode
        .getORGStructNodes(this.$store.state.user.currentCompanyId)
        .then((res) => {
          if (res) {
            let data = res.data.sort((a, b) => {
              return a.orderNum - b.orderNum;
            });
            let frameworkData = creatTreeJson(data, 0);
            vm.frameworkData = frameworkData;
            vm.measureChoiceVisible = true;
          }
        });
    },
    bindNodeClick(node) {
      let vm = this;
      //获取组织架构节点
      if (vm.activeName == "0") {
        vm.getUserMeasureId();
      } else if (vm.activeName == "1") {
        vm.$api.orgStructNode.getMountedMeasures(node.id).then((res) => {
          if (res) {
            vm.measureTable = res.data;
          }
        });
      } else if (vm.activeName == "2") {
        vm.$api.view.getViewTreeNodes(node.id).then((res) => {
          if (res) {
            vm.viewmeasureTable = res.data;
          }
        });
      } else if (vm.activeName == "3") {
        if (node.hasOwnProperty("disabled")) {
        } else {
          vm.$api.measuringClassification
            .getMeasuresFromGroup([node.id])
            .then((res) => {
              vm.classmeasureTable = res.data[0].measures;
            });
        }
      }
    },
    //获取视图树
    getViewTree() {
      let vm = this;
      vm.$api.view
        .getCompanyViewTreesInfo(this.$store.state.user.currentCompanyId)
        .then((res) => {
          res.data.forEach((item) => {
            item.name = item.displayName;
          });
          vm.viewData = res.data;
          // if (res) {
          //   let data = res.data.sort((a, b) => {
          //     return a.orderNum - b.orderNum;
          //   });
          //   let frameworkData = creatTreeJson(data, 0);
          //   vm.viewData = frameworkData;
          //   vm.measureChoiceVisible = true;
          // }
        });
    },
    //获取分类分组
    getMeasuringClass() {
      this.$api.measuringClassification
        .getMeasureGroup4(this.$store.state.user.currentCompanyId)
        .then((res) => {
          for (let i = 0; i < res.data[0].length; i++) {
            let item = res.data[0][i];
            item.parentId = "0";
            item.label = item.classDisplayName;
            item.id = item.classId;
            item.disabled = true;
            // res.data[0][i]["id"]=res.data[i].classId
            if (item.groups.length > 0) {
              for (let j = 0; j < item.groups.length; j++) {
                item.groups[j].parentId = item.classId;
                item.groups[j].label = item.groups[j].groupDisplayName;
                item.groups[j].id = item.groups[j].groupId;
              }
              // item=res.data[i].groups
            }
          }
          this.classData = res.data[0];
        });
    },
    clicktable(row) {
      if (this.activeName == "0") {
        this.$emit("clicktable", row);
      }
      if (this.activeName == "1") {
        this.$emit("clicktable", row);
      } else if (this.activeName == "2") {
        let data = {};
        data.id = row.measureId;
        data.name = row.measureName;
        data.remark = row.measureRemark;
        this.$emit("clicktable", data);
      } else if (this.activeName == "3") {
        this.$emit("clicktable", row);
      }
    },
    handleClick() {
      if (this.activeName == "0") {
        this.getUserMeasureId();
      } else if (this.activeName == "1") {
        this.bindShowMeasureChoice();
      } else if (this.activeName == "2") {
        this.getViewTree();
      } else if (this.activeName == "3") {
        this.getMeasuringClass();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  margin-top: 5px;
  margin-bottom: 5px;
  .el-tabs__nav-scroll {
    height: 70%;
  }
}
.choice-warp {
  display: flex;
  height: 615px;
  width: 300px;
  margin-left: 30px;
}
.choice-left {
  flex: 0 0 255px;
  margin-right: 35px;
  border: 1px solid;
  overflow: auto;
}
.choice-right {
  flex: 0 0 320px;
}
</style>
